// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';

/* eslint-disable react/no-multi-comp */

function getLink() {

    return (
        <Link
            to={this.link}
        >
            {this.label}
        </Link>
    );

}

function getButton() {

    return (
        <button
            className='button-text'
            onClick={this.onClick}
        >
            {this.label}
        </button>
    );

}

/* eslint-disable react/no-multi-comp */

const ActionLink = props => {

    const disabledLink = (
        <span className='disabled-link'>
            {props.label}
        </span>
    );

    const map = {
        'button-link': props::getButton,
        'navigation-link': props::getLink
    };

    return props.isDisabled ?
        disabledLink :
        map[props.type]();

};

ActionLink.displayName = 'ActionLink';
ActionLink.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    link: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string
};
export default ActionLink;



// WEBPACK FOOTER //
// ./src/shared/components/action-link/index.js